module.exports = __webpack_public_path__ + "img/01.cd5a3e22.png";